export default "__VITE_ASSET__ea9d5c83__"